export const FETCH_IDENTIFIERS = 'fetchIdentifiers';
export const FETCH_TEMPLATES = 'fetchTemplates';
export const FETCH_SINGLE_TEMPLATE = 'fetchSingleTemplate';
export const STORE_TEMPLATE = 'storeTemplate';
export const DELETE_TEMPLATE = 'deleteTemplate';
export const RESET_STATE = 'resetState';
export const UPDATE_TEMPLATE = 'updateTemplate';